export const EVENT_COVER_HEIGHT = Object.freeze({
  s: 170,
  m: 149,
  l: 157,
  xl: 168,
});

export const NEWS_COVER_HEIGHT = Object.freeze({
  s: 143,
  m: 133,
  l: 116,
  xl: 168,
});

export const INITIAL_DYNAMIC_ATTRIBUTES = ({ isTopic }) =>
  Object.freeze({
    query: {
      numberOfItems: 12,
      dataDiscussionsType: 'last_published',
      dataType: 'upcoming',
      dataUserType: 'recently_joined',
      dataTopicType: 'last_created',
      dataPostsType: isTopic ? 'last_created' : 'top_post',
    },
    singleLine: true,
    type: 'empty',
    title: __('Connect with others'),
    headlines: {
      discussions: __('Discussions'),
      events: __('Events'),
      news: __('News'),
      posts: s__('Builder|Live Feed posts'),
      topics: __('Groups'),
    },
    firstSubline: {
      display: true,
      type: 'job',
    },
    secondSubline: {
      display: false,
      type: 'job',
    },
  });
